import { message } from 'antd';
import * as Sentry from '@sentry/react';
import {
  createBearerAuthClient,
  setupErrorInterceptor,
  type ProcessedError,
  type ApiErrorContext,
} from '@raporgor/api-client';

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:5013';

// Token key used in localStorage
const TOKEN_KEY = 'token';
const USER_KEY = 'user';

// Handle unauthorized (401) - redirect to login
const handleUnauthorized = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  window.location.href = '/login';
};

// Create the API client with bearer auth
export const apiClient = createBearerAuthClient(
  API_URL,
  TOKEN_KEY,
  handleUnauthorized
);

// Add custom error interceptor for UI notifications
setupErrorInterceptor(apiClient, {
  onError: (error: ProcessedError) => {
    // Show toast notification for errors
    if (error.severity === 'error') {
      message.error(error.message);
    } else if (error.severity === 'warning') {
      message.warning(error.message);
    }
  },
  reportToSentry: (axiosError, context?: ApiErrorContext) => {
    Sentry.captureException(axiosError, {
      extra: context ? { ...context } : undefined,
    });
  },
});
